export default function provisionalModuleDataBasedOnLanguage(language) {
  if (!language || language === "nb-NO" || language === "no-NO") {
    return {
      unitButtonLabel: "Vis valg",
      amenitiesLabel: "Fasiliteter",
      activitiesLabel: "Aktiviteter",
      restaurantLabel: "Restaurant",
      roomsLabel: "Rom",
      cabinsLabel: "Din bestilling",
      descriptionLabel: "Beskrivelse",
      locationLabel: "Plassering",
      policiesLabel: "Retningslinjer",
      showMoreButtonLabel: "Vis mer",
      showLessButtonLabel: "Vis mindre",
      showAllButtonLabel: "Vis alle",
      dateFormLabel: "Velg ankomst og avreisedato",
      formTitleActivities: "Når kommer du?",
      paxFormLabel: "Hvem kommer?",
      datePickerPlaceholderStart: "Startdato",
      adultsLabel: "Voksne",
      childrenLabel: "Barn",
      childLabel: "Child",
      searchButtonLabel: "Søk",
      checkinLabelPlaceholder: "Sjekk inn",
      checkoutLabelPlaceholder: "Sjekk ut",
      ageRequiredLabel: "Barnas alder",
      ageRequiredCaption: "(når du er på ferie)",
      ageLabel: "år gammel",
      buttonOpenGalleryPicturesLabel: "Bilder",
      buttonOpenGalleryViewLabel: "Se",
      availabilityLabel: "Tilgjengelighet",
      optionSelectionLabel: "Velg et alternativ",
      selectLabel: "Velg",
      bookLabel: "Book",
      noResultsLabel: "er ikke tilgjengelig med søkekriteriene dine.",
      searching: "Søker...",
      lodgingOffers: "Overnattingstilbud",
      filtersPropertyNameLabel: "Eiendomsnavn",
      filtersActivityNameLabel: "Aktivitetsnavn",
      filtersLabelPrice: "Pris",
      filtersAmenityLabel: "Eiendomsfasiliteter",
      filterSupplierTypeLabel: "Overnattingstype",
      inputPlaceholder: "Skriv inn et egenskapsnavn",
      showLessAmenitiesLabel: "Vis færre fasiliteter",
      showAllAmenitiesLabel: "Vis alle fasiliteter",
      modalAddTitle: "Vil du legge til",
      modalAddTitle2: "to your shopping cart?",
      modalCtaBack: "Back to the list",
      modalCtaAdd: "Legg i handlekurv",
      searchResultLabel: "Søkeresultat",
      addedToCart: "har blitt lagt til i handlekurven din.",
      addingToCart: "Legger til i handlekurven...",
      goToCart: "Gå til handlekurven",
      room: "Rom",
      addRoom: "Legg til et annet rom",
      cabin: "Hytter",
      apartment: "Leiligheter",
      hotel: "Hotell",
      errorAdding: "Noe gikk galt under forsøket på å legge til dette produktet i handlekurven. Prøv igjen senere.",
      unavailableLabel: "Ikke tilgjengelig på valgte datoer",
      guests: "Gjester",
      displayedLabel: "Prisen inkluderer følgende:",
      linkToCart: "/handlekurv"
    }
  }

  if (language === "en-US") {
    return {
      unitButtonLabel: "View",
      amenitiesLabel: "Amenities",
      activitiesLabel: "Activities",
      restaurantLabel: "Restaurant",
      roomsLabel: "Rooms",
      cabinsLabel: "Your order",
      descriptionLabel: "Description",
      locationLabel: "Location",
      policiesLabel: "Policies",
      showMoreButtonLabel: "Show more",
      showLessButtonLabel: "Show less",
      showAllButtonLabel: "Show all",
      dateFormLabel: "Choose Check-In and Check-Out date",
      formTitleActivities: "When are you coming?",
      paxFormLabel: "Who is coming?",
      datePickerPlaceholderStart: "Start Date",
      adultsLabel: "Adults",
      childrenLabel: "Children",
      childLabel: "Child",
      searchButtonLabel: "Search",
      checkinLabelPlaceholder: "Check in",
      checkoutLabelPlaceholder: "Check out",
      ageRequiredLabel: "Age of children",
      ageRequiredCaption: "(when you are on holidays)",
      ageLabel: "years old",
      buttonOpenGalleryPicturesLabel: "Pictures",
      buttonOpenGalleryViewLabel: "View",
      availabilityLabel: "Availability",
      optionSelectionLabel: "Select an option",
      selectLabel: "Select",
      bookLabel: "Book",
      noResultsLabel: "is not available with your search criteria.",
      searching: "Searching...",
      lodgingOffers: "Lodging Offers",
      filtersPropertyNameLabel: "Property Name",
      filtersActivityNameLabel: "Activity Name",
      filtersLabelPrice: "Price",
      filtersAmenityLabel: "Property Amenities",
      filterSupplierTypeLabel: "Supplier Type",
      inputPlaceholder: "Type a property name",
      showLessAmenitiesLabel: "Show less amenities",
      showAllAmenitiesLabel: "Show all amenities",
      modalAddTitle: "Would you like to add",
      modalAddTitle2: "to your shopping cart?",
      modalCtaBack: "Back to the list",
      modalCtaAdd: "Add to cart",
      searchResultLabel: "Search result",
      addedToCart: "has been added to your cart.",
      addingToCart: "Adding to cart...",
      goToCart: "Go to cart",
      room: "Room",
      addRoom: "Add another room",
      cabin: "Cabin",
      apartment: "Apartment",
      hotel: "Hotel",
      errorAdding: "Something went wrong trying to add this product to the cart, please try again later.",
      unavailableLabel: "Not available on selected dates",
      guests: "Guests",
      displayedLabel: "The displayed price includes:",
      linkToCart: "/en-US/shopping-cart"
    }
  }

  if (language === "fr-FR") {
    return {

    }
  }

  return {

  }
}